import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { NewPaymentPage } from '@/features/payments/new-payment-page'
import { requirePermission } from '@/lib/route-guards'

/** Parámetros de búsqueda: `?loanId=` preselecciona el préstamo (enlace desde su detalle). */
const newPaymentSearchSchema = z.object({
  loanId: z.string().uuid().optional().catch(undefined),
})

/** Registrar pago. */
export const Route = createFileRoute('/_app/payments/new')({
  beforeLoad: requirePermission('payments:post'),
  validateSearch: newPaymentSearchSchema,
  component: NewPaymentRoute,
})

function NewPaymentRoute() {
  const { loanId } = Route.useSearch()
  return <NewPaymentPage loanId={loanId} />
}
